<template>
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">

            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-9">
                    <div class="flex gap-2 border border-gray-200 rounded">
                        <input
  type="text"
  class="w-full px-3 py-2 border-0 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm text-gray"
                                v-model="search"
                                @keyup="onSearch"
                                placeholder="Search name">
                        <button type="button" class="px-3 bg-white hover:bg-gray-50" @click="onSearch">
                            <i class="fas fa-search text-gray hover:text-primary"></i>
                        </button>
                    </div>
                </div>
                <div class="col-span-3">
                    <select v-model="limit" @change="fetch" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary">
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-4 mt-2">
                <div class="col-span-6">
                    <div class="flex gap-2 border border-gray-200 rounded">
                        <input
  type="text"
  class="w-full px-3 py-2 border-0 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm text-gray"
                                v-model="phone"
                                @keyup="onSearch"
                                placeholder="Phone number 2567XXXXXXX">
                        <button type="button" class="px-3 bg-white hover:bg-gray-50" @click="onSearch">
                            <i class="fas fa-phone text-gray hover:text-primary"></i>
                        </button>
                    </div>
                </div>
                <div class="col-span-6">
                    <div class="flex gap-2 border border-gray-200 rounded">
                        <input
  type="text"
  class="w-full px-3 py-2 border-0 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm text-gray"
                                v-model="email"
                                @keyup="onSearch"
                                placeholder="email  eg. xx@gmail.com">
                        <button type="button" class="px-3 bg-white hover:bg-gray-50" @click="onSearch">
                            <i class="fas fa-envelope text-gray hover:text-primary"></i>
                        </button>
                    </div>
                </div>

            </div>
            <div class="grid grid-cols-12 gap-4 mt-2">
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12">
                            <span v-if="loading" class="lds-ring">
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                            </span>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-4 flex py-2 px-3 border-b border-gray-10 hover:bg-gray-10" v-for="(client, idx) in clients" :key="idx">
                        <div class="col-span-9">
                            <div class="flex">
                                <div class="col-span-12 ml-3">
                                    <div class="grid grid-cols-12 gap-4">
                                        <div class="col-span-12">
                                            <p class="text-sm text-uppercase" v-if="client">
                                                <span v-if="client.givenName">{{ client.givenName }}</span>
                                                <span class="mx-1" v-if="client.surName">{{ client.surName }}</span>
                                                <span class="mx-1"
                                                      v-if="client.middleName">{{ client.middleName }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-12 gap-4">
                                        <div class="col-span-12">
                                            <p class="text-xs text-lowercase text-gray italic" v-if="client">
                                                {{ client.email }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-3">
                            <button @click="selectAccount(client)"
                                    :class="[ selectedId === client.id ? 'btn-primary button active' : 'btn-primary button' ]">
                                Select <i v-if="loadingTransfer && selectedId === client.id"
                                          class="text-white fa fa-check-circle mx-1"></i>
                            </button>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-4 flex py-1 px-2 bg-gray-10" v-if="clients.length === 0">
                        <div class="col-span-12 text-center">
                            <p class="text-xs">No Account Found</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useAccountStore } from "../stores";
import jwtService from "@/app/services/jwt.service";

interface Props {
  type?: string
}

interface Client {
  id: string
  givenName: string
  surName: string
  middleName?: string
  email: string
}

interface UserProfile {
  [key: string]: any
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'selected', client: Client): void
}>()

const store = useStore()
const accountStore = useAccountStore();

const search = ref<string | null>(null)
const phone = ref<string | null>(null)
const email = ref<string | null>(null)
const loading = ref(false)
const loadingTransfer = ref(false)
const selectedId = ref<string | null>(null)
const userProfile = ref<UserProfile>({})
const limit = ref(15)
const clients = ref<Client[]>([])

const getTransferDetails = computed(() => store.getters.getTransferDetails)
const getTransferError = computed(() => store.getters.getTransferError)

const objectToQueryParams = (obj: Record<string, any>): string => {
  return Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&')
}

const fetch = () => {
  loading.value = true
  onSearch()
}

const onSearch = () => {
  loading.value = true
  const filters: Record<string, any> = {
    perPage: limit.value
  }

  if (search.value) {
    filters.name = search.value
  }

  if (phone.value) {
    filters.phone = phone.value
  }

  if (email.value) {
    filters.email = email.value
  }

  accountStore.searchClients(objectToQueryParams(filters));
}

const selectAccount = (client: Client) => {
  loadingTransfer.value = true
  selectedId.value = client.id
  emit('selected', client)
}

onMounted(() => {
  fetch()
  userProfile.value = jwtService.getUser()
})

watch(() => accountStore.clients, (data) => {
  if (data) {
    loading.value = false
    clients.value = data.content
  }
})

watch(getTransferDetails, (data) => {
  if (data) {
    loading.value = false
    // successToast would need to be injected
    window.location.reload()
  }
})

watch(getTransferError, (error) => {
  if (error) {
    loading.value = false
    // errorToast would need to be injected
  }
})
</script>

